import { authFetch } from "@/api/authFetch.ts"
import { API_BASE } from "@/config.ts"

export const importKPIValues = async (file: File, endpoint: string) => {
  const formData = new FormData()
  formData.append("file", file)
  return await authFetch(`${API_BASE}/${endpoint}`, {
    method: "POST",
    body: formData,
  })
}
